import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class NotifierApiInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes(environment.notifier_service)) {
      const headers: Record<string, string> = {
        'Authorization': environment.notifier_api_key,
      };

      if (['POST', 'PUT', 'PATCH'].includes(req.method)) {
        headers['Content-Type'] = 'application/json';
      }

      const apiReq = req.clone({
        setHeaders: headers
      });

      return next.handle(apiReq);
    }

    return next.handle(req);
  }
}
